export default __webpack_public_path__ + "static/media/logotelin2.4b1083b7.png";